/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { TicketDeskFooter } from '../../../shared/ticket/TicketDeskFooter';
import type { CashVm } from './cashManagement.types';

export function CashHistoryPagination({
  vm,
  mobile: _mobile,
}: {
  vm: CashVm;
  mobile?: boolean;
}) {
  const totalCount = vm.historyTotalCount ?? 0;
  const pageSize = vm.historyPageSize;
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));

  // Canon Square: ocultar paginación si cabe en 1 página.
  if (totalPages <= 1 && !vm.historyLoading) {
    return null;
  }

  return (
    <TicketDeskFooter
      pageIndex={vm.historyPageIndex}
      pageSize={vm.historyPageSize}
      productCount={vm.cashHistory.length}
      totalCount={vm.historyTotalCount}
      hasMore={vm.historyHasMore}
      loading={vm.historyLoading}
      onPreviousPage={vm.loadHistoryPreviousPage}
      onNextPage={vm.loadHistoryNextPage}
      onGoToPage={vm.goToHistoryPage}
      embedded
    />
  );
}
